import { getData } from 'api/message'; // ajax api


const tagsView = {
    state: {
        list: [
        ],
        pagination: {},
        loading: false
    },
    mutations: {
        SET_LIST: function (state, data) {
            state.list = data.list;
            state.pagination = data.pagination
        },
        SET_LOADING: function (state, flag) {
            state.loading = flag
        }
    },
    actions: {
        // 获取消息列表
        getMessageList({ commit }, params) {
            return new Promise((resolve, reject) => {
                let _params = {
                    page: params ? params.page : 1,
                    per_page: params ? params.per_page : 10,
                }
                commit('SET_LOADING', true)
                getData(_params)
                    .then(res => {
                        commit('SET_LOADING', false)

                        if (res.code === 200) {
                            let _data = {
                                list: res.data.data || [],
                                pagination: {
                                    total: res.data.total,
                                    current_page: res.data.current_page
                                }
                            }
                            commit('SET_LIST', _data)
                        }
                        resolve(res);
                    })
                    .catch(error => {
                        commit('SET_LOADING', false)

                        reject(error);
                    });
            });
        }
    }
};

export default tagsView;


// WEBPACK FOOTER //
// ./src/store/modules/message.js